<template>
    <ul class="SocialLinks">
        <li>
            <a href="https://open.spotify.com/artist/4jfDRsncQ0Z4DFMxLqWsli" target="_blank">Spotify</a>
        </li>
        <li>
            <a href="https://instagram.com/taurofficial/" target="_blank">Instagram</a>
        </li>
    </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'SocialLinks',
})
</script>

<style lang="scss">
.SocialLinks {
    display: flex;
    width: 400px;
    justify-content: center;
    font-family: 'Open Sans', sans-serif;
    text-transform: uppercase;

    a {
        margin-right: 20px;
        text-decoration: none;
    }
}
</style>